import { useEffect, useState } from "react";

const CHECK_MOBILE_REGEXP = /android|iphone|kindle|ipad/i;

export default function useMobileCheck() {
  const [isMobileDevice, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(CHECK_MOBILE_REGEXP.test(navigator.userAgent) || window.innerWidth <= 630);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return { isMobileDevice };
}
